module.exports = __webpack_public_path__ + "static/twin-nephrite-87219428572628139671850618f9982d.png";